import React from 'react';
import LogoPanelHeader from './SignedOut/LogoPanelHeader';
import SignedOutFooter from './SignedOut/SignedOutFooter';

const propTypes = {};
const defaultProps = {};

function NotFound(props) {
    return (
        <div className="fill signed-out">
            <div className="container rel-centered-v">
                <div className="col-12 col-sm-6 offset-sm-3">
                    <div className="signed-out-panel">
                        <LogoPanelHeader message="Page not found."/>
                    </div>
                </div>
            </div>
            <SignedOutFooter/>
        </div>
    );
}

NotFound.propTypes = propTypes;
NotFound.defaultProps = defaultProps;

export default NotFound;